/**
 * consent-banner-style
 * -------------------------------------------------------------------------------------------------
 * Restyles the Pandectes consent banner from a full-width bottom bar into a lifted card with larger
 * buttons. Meta traffic lands straight on a product page and meets this before anything else, so it
 * should read as a decision to make rather than a strip to ignore.
 *
 * WHY IT IS DONE FROM JAVASCRIPT
 * The banner lives inside `<pandectes-cmp>`'s shadow root. Theme CSS cannot cross that boundary, so
 * the only way in from our side is to append a stylesheet to the shadow root itself. The root is
 * `open`, which makes this possible; if Pandectes ever closes it this file simply stops having an
 * effect and nothing breaks.
 *
 * 🚨 WORDING IS NOT TOUCHED. Every market runs its own consent text — Germany's is longer because it
 * has to be — and all of it is authored in the Pandectes admin. This file only changes layout and
 * sizing. Never put copy in here.
 *
 * ⚠️ Class names below (`.dialog.notice`, `.actions`, `.filled`, `.outlined`) are Pandectes' own and
 * could change on an app update. The failure mode is cosmetic: the banner falls back to the app's
 * default bar. Worth a look after any Pandectes release.
 */
(() => {
  const CSS = `
    /* DESKTOP. Pandectes leaves a large vertical pause between the privacy heading and the
       explanatory line in its full-width bar. Keep the bar and actions exactly as supplied by
       the CMP, but make the two pieces of copy read as one compact group. */
    @media (min-width: 768px) {
      /* The current Pandectes bar is identified reliably by its two-row inner-grid/has-header
         layout; the former .dialog.notice wrapper selector is not present in every render.
         Move only the left body copy visually upward. Relative positioning preserves the grid's
         measured height, so the bar and all three action buttons keep their existing dimensions. */
      .inner.inner-grid.has-header { row-gap: 0 !important; }
      .inner.inner-grid.has-header > .header { margin: 0 !important; }
      .inner.inner-grid.has-header > .header > h2 { margin-block: 0 !important; }
      .inner.inner-grid.has-header > .body {
        position: relative;
        top: -6px;
        margin: 0 !important;
        padding-top: 0 !important;
      }
      .inner.inner-grid.has-header > .body .intro { margin-block: 0 !important; }
      .inner.inner-grid.has-header > .body .links { margin-top: 2px !important; }
    }

    /* 🚨 PHONE ONLY. On desktop the app's full-width bottom bar is the right shape and was never the
       problem — the card treatment below is there because the bar covered the product on a phone.
       Applying it at every width left desktop with a small box floating in the middle of nothing. */
    @media (max-width: 767.98px) {
      /* Pandectes changed the notice from a native dialog element to a DIV with the same classes.
         Keep every proven mobile dimension below; only the selector changes so the existing card,
         rounded buttons and full-page backdrop become active again. */
      :host .dialog.notice.bar,
      .dialog.notice.bar {
        inset-inline: 0 !important;
        width: auto !important;
        max-width: none !important;
        margin: 0 12px 12px 12px !important;
        border-radius: 16px !important;
        padding: 14px 16px !important;
        background: #fff;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.13) !important;
      }

      .dialog.notice .inner-grid { gap: 8px !important; }
      .dialog.notice .header { margin-bottom: 0 !important; }
      .dialog.notice .title { font-size: 0.9375rem !important; margin: 0 !important; }
      .dialog.notice .body,
      .dialog.notice .intro { margin: 0 !important; }
      .dialog.notice .message { line-height: 1.4; font-size: 0.8125rem; }
      .dialog.notice .links { margin-top: 2px !important; }
      .dialog.notice .actions { gap: 6px !important; margin-top: 0 !important; }

      .dialog.notice .actions button {
        min-height: 44px !important;
        font-size: 15px;
        font-weight: 500;
        border-radius: 10px;
      }

      .dialog.notice .actions button.outlined {
        min-height: 42px !important;
        font-weight: 400;
      }
    }
  `;




  const NOEGLE = 'data-lelafine-consent-style';

  function paafoer() {
    const vaert = document.querySelector('pandectes-cmp');
    const sr = vaert && vaert.shadowRoot;
    if (!sr) return false;
    if (sr.querySelector(`style[${NOEGLE}]`)) return true;

    const el = document.createElement('style');
    el.setAttribute(NOEGLE, '1');
    el.textContent = CSS;
    // Appended last so it wins over Pandectes' own stylesheet without needing !important.
    sr.appendChild(el);
    return true;
  }

  if (paafoer()) return;

  // The element is injected by the app, so it is usually not there yet on first run.
  const obs = new MutationObserver(() => {
    if (paafoer()) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Belt and braces: stop watching after 20s whatever happened.
  setTimeout(() => obs.disconnect(), 20000);
})();
